module.exports = __webpack_public_path__ + "img/footer-image.2c75d8e8.png";